module.exports = __webpack_public_path__ + "img/support copy.7f4d4269.svg";